// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__2KQn9","obliqueLineWrap":"membershipbadge_obliqueLineWrap__1rmM5","obliqueLine":"membershipbadge_obliqueLine__3If0H"};